export interface IConnectToDonorStatus {
    id: number,
    description: string,
    isClosed: boolean
}